import React, { useCallback } from 'react';
import dealsStore from '../../store/dealsStore';
import { localeStore } from 'src/mobx/localesStore';
import { modalStore } from 'src/mobx/modalStore';
import { formatPrice } from 'src/utils/formatter';
import FakePicker from 'src/view/components/Controls/Pickers/FakePicker/FakePicker';
import DeleteRestoreBlock from 'src/view/components/DeleteRestoreBlock/DeleteRestoreBlock';

interface IProps {
  onDelete: () => void;
}

const FakeDealsItem: React.FC<IProps> = (props: IProps): JSX.Element => {
  const openItemsModal = useCallback(() => {
    if (!dealsStore.deal) return;
    modalStore.openItemsForDealModal({
      selectedItems: dealsStore.deal.items,
      onSave: dealsStore.addItem,
      isMulti: true,
    });
  }, []);

  return (
    <li className="deals-item">
      <FakePicker
        placeholder={localeStore.t('combo_offer_item')}
        onClick={openItemsModal}
        className="deals-item__input mr-3"
        textClassName="family-medium"
      />
      <FakePicker
        withoutIcon
        placeholder={localeStore.t('Value')}
        onClick={openItemsModal}
        className="deals-item__input mr-3"
        textClassName="family-medium"
      />
      <div className="deals-item__input-price">
        <p className="family-medium color-dark text-size-18">{formatPrice(0)}</p>
      </div>
      <div className="d-flex flex-row align-items-center ml-4 mt-2">
        <DeleteRestoreBlock onDelete={props.onDelete} iconClassName="color-gray2" />
      </div>
    </li>
  );
};

export default FakeDealsItem;
